import {
  CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM,
  ChemistryReactionRole,
} from 'notebook/integrations/chemistry/ChemistryStructuredTableConstants';
import {
  StoichiometryStructuredTableMetadata,
  StoichiometryStructuredTableRowMetadata,
} from 'notebook/integrations/chemistry/StoichiometryStructuredTableAdapter';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {CustomEval} from 'notebook/tables/constants/CustomEvalConstants';
import {coerceToPrimitiveBoolean, formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {EMPTY_TYPED_VALUE} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {ResolveQueryFn} from 'notebook/tables/typed-values/TypedValueResolution';
import {getEnumValue} from 'util/enumIncludes';

type LimitingReactantCellDependencies = [isFirstRow: TypedValue | null, reactionRole: TypedValue | null];
interface LimitingReactantValues {
  isFirstRow: boolean;
  reactionRole: ChemistryReactionRole | undefined;
}

function transformCellDependenciesToValues(
  cellDependencies: LimitingReactantCellDependencies
): LimitingReactantValues {
  const [isFirstRowTypedValue, reactionRoleTypedValue] = cellDependencies;
  const isFirstRow = coerceToPrimitiveBoolean(isFirstRowTypedValue) ?? false;
  const reactionRole = reactionRoleTypedValue
    ? getEnumValue(
        ChemistryReactionRole,
        CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM[formatTypedValue(reactionRoleTypedValue)] ?? ''
      )
    : undefined;
  return {
    isFirstRow,
    reactionRole,
  };
}

const limitingReactantCustomEval: CustomEval<{
  tableMetadata: StoichiometryStructuredTableMetadata;
  rowMetadata: StoichiometryStructuredTableRowMetadata;
}> = (
  typedValue: TypedValue,
  columnDefinition: ColumnDefinition,
  cellDependencies: Array<TypedValue | null>,
  customEvalOptions: unknown,
  resolveFromResolutionQuery: ResolveQueryFn
) => {
  const {isFirstRow, reactionRole} = transformCellDependenciesToValues(
    cellDependencies as LimitingReactantCellDependencies
  );
  if (reactionRole === ChemistryReactionRole.REACTANT) {
    return {val: {type: BaseTypedValueType.BOOLEAN, booleanValue: isFirstRow}, error: null, locked: false};
  }
  return {val: EMPTY_TYPED_VALUE, error: null, locked: false};
};

export default limitingReactantCustomEval;
